import React from "react";

import { IInformations } from "../../interfaces/informations";

import { Loader } from "../../svg/Loader";

import { Container, Verifying, Error } from "./styles";

const ForwardInformations: React.ForwardRefRenderFunction<
  HTMLDivElement,
  IInformations
> = ({ verifying, validate, error, name }, ref) => {
  if (verifying) {
    return (
      <Verifying>
        <i>
          <Loader />
        </i>{" "}
        Verificação...
      </Verifying>
    );
  }

  if (error && !validate) {
    return (
      <Error {...{ ref, className: `input-info error ${name}` }}>{error}</Error>
    );
  }

  return <Container {...{ ref, className: `input-info ${name}` }}></Container>;
};

export const Informations = React.forwardRef(ForwardInformations);
